import { InvoiceData } from "../../components/datatable/invoiceData";

const InvoiceTable = () => {
  return <InvoiceData />;
};

export default InvoiceTable;
